export default __webpack_public_path__ + "images/baa7598db71fe24bd858bdf064e91c8a-product-image.png";